export const MyTeamsProfileDepartmentFilterReducer = (state = {}, action) => {
    if (action.type === 'GET_UPG_MY_TEAM_PROFILE_DEPARTMENT_FILTER') {
      return {
        ...state,
        myTeamsProfileDepartmentFilterDetails: action.payload,
      };
    } else {
      return state;
    }
  };
  